import service from '../axios'

const WEBSITE_TYPE = 0

export const articleApi = {
  // 获取文章列表
  data(params = {}) {
    return service.get('/www/article/data', {
      params: {
        ...params,
        type: WEBSITE_TYPE
      }
    })
  },
  // 获取文章详情
  get(id) {
    return service.get('/www/article/get', {
      params: {
        id,
        type: WEBSITE_TYPE
      }
    })
  }
}
